import { getLanguage, type LanguageCode } from '../i18n/languages'

/**
 * Circular flag for a language. The source SVGs are square; `object-cover` +
 * `rounded-full` clips them to the circle the design uses in the pill and menu.
 *
 * Decorative by default (`alt=""`): every place a flag appears is paired with a
 * visible text label (abbreviation or endonym), so the flag adds no information
 * for assistive tech. Size is controlled by `className` (defaults to size-6).
 */
export function Flag({ code, className }: { code: LanguageCode; className?: string }) {
  const { flag } = getLanguage(code)
  return (
    <img
      src={flag}
      alt=""
      aria-hidden="true"
      width={24}
      height={24}
      className={`shrink-0 rounded-full object-cover ${className ?? 'size-6'}`}
    />
  )
}
